import { Moment } from 'moment';
import { apiGet, API_URI } from './index';

const influencerComparison = {
    getAll: async (authorIds: string, dateFrom: Moment, dateTo:  Moment, streamIds: string, projectId: number) => {
        const data = await apiGet(`${API_URI}/api/influencercomparison/get?influencers=${authorIds}&fromDate=${dateFrom.format("YYYY-MM-DD")}&endDate=${dateTo.format("YYYY-MM-DD")}&projectId=${projectId}&streamIds=${streamIds}`);
        return data;
    }
}

export default influencerComparison;